import React from 'react';
import { withRouter } from 'react-router-dom';

import { VpIconButton } from '../VpIconButton';

export const VpBackButton = withRouter(({ history, onBack, backLinkOverride }) => {
  const handleClick = () => {
    onBack && onBack();
    backLinkOverride ? history.push(backLinkOverride) : history.goBack();
  };

  return (
    <VpIconButton size="small" isSquare color="neutral" icon="ArrowUpLeft" onClick={handleClick} />
  );
});

export default VpBackButton;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpBackButton/VpBackButton.jsx